export const LocalStore = {
  ACTIVE_THEME: `stActiveTheme-${window.location.pathname}`,
}
